import React, { useState, useEffect, useMemo } from "react";
import {
	Table,
	Spin,
	Flex,
	Badge,
	Select,
	Space,
	Input,
	Typography,
	Button as ButtonS,
	Tooltip,
	Modal,
	Progress,
	Dropdown,
	Menu,
	Checkbox,
	Form,
	Alert,
	Segmented,
	message,
} from "antd";
import { useNavigate } from "react-router";
// import Button from '../../../../../components/Button';
import { Button } from "antd";
import axios from "axios";
import {
	SearchOutlined,
	FilterOutlined,
	InfoCircleOutlined,
	PushpinOutlined,
	DownOutlined,
	EyeOutlined,
	CheckOutlined,
	CopyOutlined,
} from "@ant-design/icons";
import useDebouncedOnChange from "../../../../../functions/useDebouncedOnChange";
import datetimeParser from "../../../../../functions/datetimeParser";
import filterOption from "../../../../../components/filterOption";
import CaseStatus from "../../../components/caseStatus";
import SimpleAvatar from "../../../components/simpleAvatar";
import HighlightShort from "../../../../../components/HighlightShort";
import Highlight from "../../../../../components/HighlightShort";
import { UserContext } from "../../../components/privateroute";
import IsFavorite from "../../../components/IsFavorite";
import AdvancedSearching from "../advancedSearching";
import CanWrapper from "../../../../../components/Can";
import UserRaport from "../userRaport";
import saveToLocalStorage from "../../../../../functions/saveToLocalStorage";
import { GlobalContainerContext } from "../../../components/privateroute";
import BulkEdit from "../bulkEdit";
const { Text } = Typography;

const defaultKeyPrefix = "sprawy";

const makeStorageKeys = (prefix = defaultKeyPrefix) => {
	const safePrefix =
		typeof prefix === "string" && prefix.length > 0
			? prefix
			: defaultKeyPrefix;
	return {
		tableState: `${safePrefix}TableState`,
		visibleColumns: `${safePrefix}VisibleColumns`,
		navIds: `${safePrefix}NavIds`,
		navMeta: `${safePrefix}NavMeta`,
		search: `${safePrefix}Search`,
		advancedSearch: `${safePrefix}AdvancedSearch`,
		tagFilter: `${safePrefix}TagFilterIds`,
		selectedStatusFilter: `${safePrefix}SelectedStatusFilter`,
		currentPage: `${safePrefix}CurrentPage`,
	};
};

const LOCKED_COLUMN_KEYS = new Set([
	"bulk_edit_checkbox",
	"ticketid",
	"subject",
	"status",
]);

const DEFAULT_OPTIONAL_COLUMN_KEYS = [
	"competitionis",
	"next_reminder_dateline",
	"lastactivity",
	"accident_dateline",
	"phone",
	"przypisany",
];

const COLUMN_LABELS = {
	competitionis: "Konkurencja",
	next_reminder_dateline: "Przypomnienie",
	lastactivity: "Ostatnia zmiana",
	accident_dateline: "Data zdarzenia",
	phone: "Zgłaszający",
	przypisany: "Przypisany",
};

const normalizeVisibleColumns = (value) => {
	const list = Array.isArray(value) ? value : [];
	const normalized = list.filter((key) =>
		DEFAULT_OPTIONAL_COLUMN_KEYS.includes(String(key)),
	);
	return [...new Set(normalized)];
};

const normalizeIdList = (value) => {
	if (!value) return [];
	const list = Array.isArray(value) ? value : [value];
	return [
		...new Set(
			list.map((x) => Number(x)).filter((x) => Number.isFinite(x)),
		),
	];
};

const buildTerritoryAdvancedSearchFromAreas = (areas) => {
	const areaList = Array.isArray(areas) ? areas : [];
	const wojIds = normalizeIdList(
		areaList
			.map((a) => a?.woj ?? a?.wojewodztwo ?? a?.woj_id ?? a?.wojId)
			.filter((x) => x != null),
	);
	const powiatIds = normalizeIdList(
		areaList
			.map((a) => a?.powiat ?? a?.powiat_id ?? a?.powiatId)
			.filter((x) => x != null),
	);
	const gminaIds = normalizeIdList(
		areaList
			.map((a) => a?.gmina ?? a?.gmina_id ?? a?.gminaId)
			.filter((x) => x != null),
	);

	const filters = [];
	if (wojIds.length) {
		filters.push({
			name: "swadministrationelementsticket.woj",
			value: [wojIds],
		});
	}
	if (powiatIds.length) {
		filters.push({
			name: "swadministrationelementsticket.powiat",
			value: [powiatIds],
		});
	}
	if (gminaIds.length) {
		filters.push({
			name: "swadministrationelementsticket.gmina",
			value: [gminaIds],
		});
	}
	return filters;
};

const TERRITORY_FILTER_NAMES = new Set([
	"swadministrationelementsticket.woj",
	"swadministrationelementsticket.powiat",
	"swadministrationelementsticket.gmina",
]);

const INACTIVE_ALLOWED_FILTERS = new Set([
	"swtickets.ticketstatusid",
	"stl.tagid",
	...TERRITORY_FILTER_NAMES,
]);

const MAIN_ALLOWED_FILTERS = new Set([
	"swtickets.dateline",
	"swtickets.accident_dateline",
	"swtickets.lastactivity",
	"swtickets.ticketstatusid",
	"stl.tagid",
	"swtickets.priorityid",
	"swticketwatchers.staffid",
	"swtickets.userid",
	"swtickets.owneruserid",
	"special",
	"favorite",
	...TERRITORY_FILTER_NAMES,
]);

const sanitizeAdvancedSearch = (advancedSearch) => {
	if (!Array.isArray(advancedSearch)) return [];
	// Only normalize known boolean-ish toggles; keep all other filters intact.
	return advancedSearch.filter((item) => {
		if (!item || typeof item !== "object") return false;
		if (item.name === "special" || item.name === "favorite") {
			return item.value === 1;
		}
		return true;
	});
};

const normalizeWhitespace = (value) => {
	if (value == null) return "";
	return String(value).replace(/\s+/g, " ").trim();
};

const normalizeStatusLabel = (value) => {
	return normalizeWhitespace(value)
		.toLowerCase()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
};

const isClosedReminderStatus = (record) => {
	const statusLabel = normalizeStatusLabel(
		record?.statustitle ?? record?.title ?? record?.status,
	);
	return statusLabel === "koniec" || statusLabel === "crm zamkniete";
};

const truncateToMaxChars = (value, maxChars) => {
	const text = normalizeWhitespace(value);
	if (!Number.isFinite(maxChars) || maxChars <= 0) return text;
	return text.length > maxChars ? text.slice(0, maxChars) : text;
};

const writeTextToClipboard = async (text) => {
	if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(text);
		return;
	}

	const textarea = document.createElement("textarea");
	textarea.value = text;
	textarea.setAttribute("readonly", "");
	textarea.style.position = "fixed";
	textarea.style.left = "-9999px";
	document.body.appendChild(textarea);
	textarea.select();
	try {
		document.execCommand("copy");
	} finally {
		document.body.removeChild(textarea);
	}
};

const DataTable = (props) => {
	const {
		departs,
		setShowFilters,
		showFilters,
		activityMode = "active",
		activityDays = null,
		storageKeyPrefix = defaultKeyPrefix,
		applyUserTerritoryFilter = false,
		filterMode = "all",
		onFilterModeChange,
		showAllTickets,
		onShowAllTicketsChange,
		showActivityRangeToggle = false,
		activityRangeValue = "active",
		onActivityRangeChange,
		ticketRouteBase = "/sprawy",
		showRightFiltersPanel = false,
	} = props;
	const globalUser = React.useContext(UserContext);
	const isAdmin = Boolean(globalUser?.isadmin);
	const { globalContainer, setGlobalContainer } = React.useContext(
		GlobalContainerContext,
	);
	const navigate = useNavigate();
	const storageKeys = makeStorageKeys(storageKeyPrefix);
	const [viewportHeight, setViewportHeight] = useState(() => {
		if (typeof window === "undefined") return 900;
		return window.innerHeight;
	});
	const [viewportWidth, setViewportWidth] = useState(() => {
		if (typeof window === "undefined") return 1600;
		return window.innerWidth;
	});
	const buildTicketPath = (ticketid) => {
		const base =
			typeof ticketRouteBase === "string" && ticketRouteBase.length
				? ticketRouteBase
				: "/sprawy";
		return base.endsWith("/")
			? `${base}${ticketid}`
			: `${base}/${ticketid}`;
	};
	const [data, setData] = useState([]);
	const [selectedStatusFilter, setSelectedStatusFilter] = useState(() => {
		try {
			const saved = JSON.parse(
				localStorage.getItem(storageKeys.tableState) ||
					(storageKeyPrefix === defaultKeyPrefix
						? localStorage.getItem("sprawyTableState")
						: null) ||
					"null",
			);
			if (saved?.selectedStatusFilter != null)
				return saved.selectedStatusFilter;
		} catch {}
		try {
			const saved =
				localStorage.getItem(storageKeys.selectedStatusFilter) ||
				(storageKeyPrefix === defaultKeyPrefix
					? localStorage.getItem("sprawySelectedStatusFilter")
					: null);
			return saved != null ? JSON.parse(saved) : null;
		} catch {
			return null;
		}
	}); // State to track selected status filter
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [selectedListUser, setSelectedListUser] = useState([]);
	const [selectedListInfo, setSelectedListInfo] = useState(null);

	const [user, setUser] = useState(null);
	const [percent, setPercents] = useState(0);
	const [pdfModal, setPdfModal] = useState(false);
	const [values, setValues] = useState(null);
	const [territoryLabelOptions, setTerritoryLabelOptions] = useState([]);
	const [userAreas, setUserAreas] = useState(null);
	const [open, setOpen] = useState(false);
	const [lists, setLists] = useState([]);
	const [bulkIDs, setBulkIDs] = useState([]);
	const [copyInProgress, setCopyInProgress] = useState(false);
	const [visibleColumnKeys, setVisibleColumnKeys] = useState(() => {
		try {
			const fromTableState = JSON.parse(
				localStorage.getItem(storageKeys.tableState) || "null",
			);
			const fromState = normalizeVisibleColumns(
				fromTableState?.visibleColumnKeys,
			);
			if (fromState.length) return fromState;
		} catch {}

		try {
			const raw = localStorage.getItem(storageKeys.visibleColumns);
			const parsed = normalizeVisibleColumns(raw ? JSON.parse(raw) : []);
			if (parsed.length) return parsed;
		} catch {}

		if (
			typeof window !== "undefined" &&
			Number(window.innerWidth || 0) <= 1400
		) {
			return [
				"next_reminder_dateline",
				"lastactivity",
				"phone",
				"przypisany",
			];
		}

		return [...DEFAULT_OPTIONAL_COLUMN_KEYS];
	});
	const [pagination, setPagination] = useState(() => {
		const savedSearch =
			localStorage.getItem(storageKeys.search) ||
			(storageKeyPrefix === defaultKeyPrefix
				? localStorage.getItem("sprawySearch")
				: null) ||
			"";
		let savedState = null;
		try {
			savedState = JSON.parse(
				localStorage.getItem(storageKeys.tableState) ||
					(storageKeyPrefix === defaultKeyPrefix
						? localStorage.getItem("sprawyTableState")
						: null) ||
					"null",
			);
		} catch {}

		const advancedSearchRaw =
			localStorage.getItem(storageKeys.advancedSearch) ||
			(storageKeyPrefix === defaultKeyPrefix
				? localStorage.getItem("advancedSearch")
				: null);
		const fallbackAdvancedSearch = advancedSearchRaw
			? JSON.parse(advancedSearchRaw).length > 0
				? sanitizeAdvancedSearch(JSON.parse(advancedSearchRaw))
				: JSON.parse(
							localStorage.getItem("globalContainer"),
					  )?.selectedList?.includes("watched")
					? [{ name: "favorite", value: 1 }]
					: []
			: [];

		const baseAdvancedSearch = sanitizeAdvancedSearch([
			...(savedState?.advancedSearch ?? fallbackAdvancedSearch),
		]);
		const filteredAdvancedSearch =
			storageKeyPrefix === "brakAktywnosci"
				? baseAdvancedSearch.filter((item) =>
						INACTIVE_ALLOWED_FILTERS.has(item?.name),
					)
				: storageKeyPrefix === defaultKeyPrefix
					? baseAdvancedSearch.filter((item) =>
							MAIN_ALLOWED_FILTERS.has(item?.name),
						)
					: baseAdvancedSearch;

		const territoryFilters = [];

		return {
			current:
				savedState?.current ??
				JSON.parse(
					localStorage.getItem(storageKeys.currentPage) ||
						(storageKeyPrefix === defaultKeyPrefix
							? localStorage.getItem("currentPage")
							: "null") ||
						"null",
				) ??
				1,
			pageSize: savedState?.pageSize ?? 20,
			list: savedState?.list ?? "none",
			total: savedState?.total ?? 0,
			search: savedState?.search ?? savedSearch,
			advancedSearch: sanitizeAdvancedSearch([
				...filteredAdvancedSearch,
				...territoryFilters,
			]),
			orderby: savedState?.orderby ?? [],
		};
	});
	const [reload, setReload] = useState(false);
	const [searchValue, setSearchValue] = useState(() => {
		return (
			localStorage.getItem(storageKeys.search) ||
			(storageKeyPrefix === defaultKeyPrefix
				? localStorage.getItem("sprawySearch")
				: null) ||
			""
		);
	}); // State to store input value
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const onResize = () => {
			setViewportHeight(window.innerHeight);
			setViewportWidth(window.innerWidth);
		};
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	useEffect(() => {
		if (storageKeyPrefix !== defaultKeyPrefix) return;
		try {
			const refreshFlag = localStorage.getItem("sprawyListRefresh");
			if (!refreshFlag) return;
			localStorage.removeItem("sprawyListRefresh");
			setPagination((prev) => ({ ...prev, current: 1 }));
			setReload((prev) => !prev);
		} catch {}
	}, [storageKeyPrefix]);

	const readTagFilterFromStorage = () => {
		try {
			const raw = localStorage.getItem(storageKeys.tagFilter);
			const parsed = JSON.parse(raw || "[]");
			return Array.isArray(parsed)
				? parsed.map((x) => Number(x)).filter((x) => Number.isFinite(x))
				: [];
		} catch {
			return [];
		}
	};

	const persistTagFilterToStorage = (ids) => {
		try {
			const safe = Array.isArray(ids)
				? ids.map((x) => Number(x)).filter((x) => Number.isFinite(x))
				: [];
			localStorage.setItem(storageKeys.tagFilter, JSON.stringify(safe));
		} catch {
			// ignore storage errors
		}
	};

	useEffect(() => {
		// Load user's action areas from DB for territory filtering.
		if (!applyUserTerritoryFilter) return;
		let mounted = true;
		const loadAreas = async () => {
			try {
				const response = await axios.post("/user/areas/get");
				const list = response?.data?.data;
				if (!mounted) return;
				setUserAreas(Array.isArray(list) ? list : []);
			} catch {
				if (!mounted) return;
				setUserAreas([]);
			}
		};
		loadAreas();
		return () => {
			mounted = false;
		};
	}, [applyUserTerritoryFilter]);

	useEffect(() => {
		if (applyUserTerritoryFilter) return;
		setUserAreas([]);
		setPagination((prev) => {
			const prevAdvancedSearch = Array.isArray(prev?.advancedSearch)
				? prev.advancedSearch
				: [];
			const withoutTerritory = prevAdvancedSearch.filter(
				(x) => !TERRITORY_FILTER_NAMES.has(x?.name),
			);
			if (withoutTerritory.length === prevAdvancedSearch.length) {
				return prev;
			}
			return { ...prev, advancedSearch: withoutTerritory, current: 1 };
		});
	}, [applyUserTerritoryFilter]);

	useEffect(() => {
		if (filterMode === "areas") {
			setPagination((prev) => {
				const prevAdvancedSearch = Array.isArray(prev?.advancedSearch)
					? prev.advancedSearch
					: [];
				const tagIds = prevAdvancedSearch
					.filter((item) => String(item?.name || "") === "stl.tagid")
					.flatMap((item) =>
						Array.isArray(item?.value) ? item.value : [],
					)
					.flatMap((value) => (Array.isArray(value) ? value : []));
				persistTagFilterToStorage(tagIds);
				const withoutTags = prevAdvancedSearch.filter(
					(item) => !String(item?.name || "").includes("stl"),
				);
				if (withoutTags.length === prevAdvancedSearch.length) {
					return prev;
				}
				return { ...prev, advancedSearch: withoutTags, current: 1 };
			});
			return;
		}

		if (filterMode === "tags") {
			const stored = readTagFilterFromStorage();
			setPagination((prev) => {
				const prevAdvancedSearch = Array.isArray(prev?.advancedSearch)
					? prev.advancedSearch
					: [];
				const withoutTags = prevAdvancedSearch.filter(
					(item) => !String(item?.name || "").includes("stl"),
				);
				const next = stored.length
					? [...withoutTags, { name: "stl.tagid", value: [stored] }]
					: withoutTags;
				if (
					JSON.stringify(next) === JSON.stringify(prevAdvancedSearch)
				) {
					return prev;
				}
				return { ...prev, advancedSearch: next, current: 1 };
			});
		}
	}, [filterMode]);

	useEffect(() => {
		if (filterMode !== "tags") return;
		const tagIds = getAdvancedSearchIds("stl.tagid");
		persistTagFilterToStorage(tagIds);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterMode, pagination.advancedSearch]);

	useEffect(() => {
		// Apply/refresh auto territory filters when DB-backed areas arrive.
		if (!applyUserTerritoryFilter) return;
		if (userAreas == null) return;
		const territoryFilters =
			buildTerritoryAdvancedSearchFromAreas(userAreas);
		setPagination((prev) => {
			const prevAdvancedSearch = Array.isArray(prev?.advancedSearch)
				? prev.advancedSearch
				: [];
			const withoutTerritory = prevAdvancedSearch.filter(
				(x) => !TERRITORY_FILTER_NAMES.has(x?.name),
			);
			const next = sanitizeAdvancedSearch([
				...withoutTerritory,
				...territoryFilters,
			]);

			// Avoid unnecessary state churn.
			if (JSON.stringify(next) === JSON.stringify(prevAdvancedSearch)) {
				return prev;
			}
			return { ...prev, advancedSearch: next, current: 1 };
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [applyUserTerritoryFilter, userAreas]);

	useEffect(() => {
		if (storageKeyPrefix !== "brakAktywnosci") return;
		setPagination((prev) => {
			const prevAdvancedSearch = Array.isArray(prev?.advancedSearch)
				? prev.advancedSearch
				: [];
			const filtered = prevAdvancedSearch.filter((item) =>
				INACTIVE_ALLOWED_FILTERS.has(item?.name),
			);
			if (filtered.length === prevAdvancedSearch.length) {
				return prev;
			}
			return { ...prev, advancedSearch: filtered, current: 1 };
		});
	}, [storageKeyPrefix]);

	useEffect(() => {
		if (storageKeyPrefix !== defaultKeyPrefix) return;
		setPagination((prev) => {
			const prevAdvancedSearch = Array.isArray(prev?.advancedSearch)
				? prev.advancedSearch
				: [];
			const filtered = prevAdvancedSearch.filter((item) =>
				MAIN_ALLOWED_FILTERS.has(item?.name),
			);
			if (filtered.length === prevAdvancedSearch.length) {
				return prev;
			}
			return { ...prev, advancedSearch: filtered, current: 1 };
		});
	}, [storageKeyPrefix]);

	useEffect(() => {
		const normalizedAdvancedSearch = sanitizeAdvancedSearch(
			pagination.advancedSearch,
		);
		const normalizedVisibleColumns =
			normalizeVisibleColumns(visibleColumnKeys);
		try {
			localStorage.setItem(
				storageKeys.tableState,
				JSON.stringify({
					current: pagination.current,
					pageSize: pagination.pageSize,
					list: pagination.list,
					total: pagination.total,
					search: pagination.search,
					advancedSearch: normalizedAdvancedSearch,
					visibleColumnKeys: normalizedVisibleColumns,
					orderby: pagination.orderby,
					departs: departs,
					selectedStatusFilter,
				}),
			);
		} catch {}
		try {
			saveToLocalStorage(storageKeys.currentPage, pagination.current);
			if (storageKeyPrefix === defaultKeyPrefix) {
				saveToLocalStorage("currentPage", pagination.current);
			}
			localStorage.setItem(storageKeys.search, pagination.search ?? "");
			if (storageKeyPrefix === defaultKeyPrefix) {
				localStorage.setItem("sprawySearch", pagination.search ?? "");
			}
			localStorage.setItem(
				storageKeys.advancedSearch,
				JSON.stringify(normalizedAdvancedSearch ?? []),
			);
			if (storageKeyPrefix === defaultKeyPrefix) {
				localStorage.setItem(
					"advancedSearch",
					JSON.stringify(normalizedAdvancedSearch ?? []),
				);
			}
			localStorage.setItem(
				storageKeys.selectedStatusFilter,
				JSON.stringify(selectedStatusFilter),
			);
			localStorage.setItem(
				storageKeys.visibleColumns,
				JSON.stringify(normalizedVisibleColumns),
			);
			if (storageKeyPrefix === defaultKeyPrefix) {
				localStorage.setItem(
					"sprawySelectedStatusFilter",
					JSON.stringify(selectedStatusFilter),
				);
				localStorage.setItem(
					"sprawyVisibleColumns",
					JSON.stringify(normalizedVisibleColumns),
				);
			}
		} catch {}
	}, [
		pagination.current,
		pagination.pageSize,
		pagination.list,
		pagination.total,
		pagination.search,
		pagination.advancedSearch,
		pagination.orderby,
		departs,
		selectedStatusFilter,
		visibleColumnKeys,
	]);

	const persistNavigationIds = (rows = data) => {
		try {
			const ids = (rows || [])
				.map((r) => r?.ticketid)
				.filter((id) => id != null);
			localStorage.setItem(storageKeys.navIds, JSON.stringify(ids));
		} catch {}
		try {
			localStorage.setItem(
				storageKeys.navMeta,
				JSON.stringify({
					current: pagination.current,
					pageSize: pagination.pageSize,
					total: pagination.total,
					activityMode,
					activityDays,
				}),
			);
		} catch {}
	};
	const setSearch = (value) => {
		setPagination({ ...pagination, search: value, current: 1 });
	};
	// Function to handle search action
	const handleSearch = () => {
		localStorage.setItem(storageKeys.search, searchValue);
		if (storageKeyPrefix === defaultKeyPrefix) {
			localStorage.setItem("sprawySearch", searchValue);
		}
		setPagination({ ...pagination, search: searchValue, current: 1 }); // Set the search value in pagination
	};
	useEffect(() => {
		setValues(null);
		const fetchData = async () => {
			const response = await axios.post("/sprawa/default/values");
			setValues(response.data);
		};
		fetchData();
	}, []);

	useEffect(() => {
		// Right panel: resolve admin element IDs to human-readable labels.
		if (!showRightFiltersPanel) return;
		if (!applyUserTerritoryFilter) return;
		const wojIds = getAdvancedSearchIds(
			"swadministrationelementsticket.woj",
		);
		const powiatIds = getAdvancedSearchIds(
			"swadministrationelementsticket.powiat",
		);
		const gminaIds = getAdvancedSearchIds(
			"swadministrationelementsticket.gmina",
		);
		const ids = [...new Set([...wojIds, ...powiatIds, ...gminaIds])];
		if (ids.length === 0) {
			setTerritoryLabelOptions([]);
			return;
		}
		let mounted = true;
		const load = async () => {
			try {
				const response = await axios.post(
					"/sprawa/administrationelements/labels",
					{ ids },
				);
				const list = response?.data?.data;
				if (!mounted) return;
				setTerritoryLabelOptions(Array.isArray(list) ? list : []);
			} catch {
				if (!mounted) return;
				setTerritoryLabelOptions([]);
			}
		};
		load();
		return () => {
			mounted = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		showRightFiltersPanel,
		applyUserTerritoryFilter,
		pagination.advancedSearch,
	]);

	useEffect(() => {
		console.log("GLOBAL: ", globalContainer);
	}, [globalContainer]);

	useEffect(() => {
		console.log(pagination.advancedSearch);
	}, [pagination.advancedSearch]);

	const debouncedOnChange = useDebouncedOnChange(setSearch);
	const updateSpecialValue = (newValue) => {
		setPagination((prevPagination) => {
			const prevAdvancedSearch = prevPagination.advancedSearch || [];
			const nextAdvancedSearch =
				newValue === 1
					? [
							...prevAdvancedSearch.filter(
								(item) => item.name !== "special",
							),
							{ name: "special", value: 1 },
						]
					: prevAdvancedSearch.filter(
							(item) => item.name !== "special",
						);

			// Return the updated pagination object
			return {
				...prevPagination,
				advancedSearch: nextAdvancedSearch,
				current: 1,
			};
		});
	};
	const updateWatchValue = (newValue) => {
		setPagination((prevPagination) => {
			const prevAdvancedSearch = prevPagination.advancedSearch || [];
			const nextAdvancedSearch =
				newValue === 1
					? [
							...prevAdvancedSearch.filter(
								(item) => item.name !== "favorite",
							),
							{ name: "favorite", value: 1 },
						]
					: prevAdvancedSearch.filter(
							(item) => item.name !== "favorite",
						);

			// Return the updated pagination object
			return {
				...prevPagination,
				advancedSearch: nextAdvancedSearch,
				current: 1,
			};
		});
	};

	const fetchListUsers = async (listId) => {
		try {
			if (!listId || listId === "none") {
				setSelectedUsers([]);
				setSelectedListInfo(null);
				setSelectedListUser(null);
				return;
			}

			const response = await axios.post("/sprawy/lists/users/get", {
				listid: listId,
			});

			const listUsers = response?.data?.data?.listusers;
			setSelectedUsers(
				Array.isArray(listUsers)
					? listUsers.map((user) => user.swlistusers_user_id)
					: [],
			);

			const listInfo = response?.data?.data?.list;
			const firstListInfo = Array.isArray(listInfo) ? listInfo[0] : null;
			setSelectedListInfo(firstListInfo || null);
			setSelectedListUser(firstListInfo?.userid ?? null);
		} catch (error) {
			console.error("Error fetching list users:", error);
			setSelectedUsers([]);
			setSelectedListInfo(null);
			setSelectedListUser(null);
			return;
		}
	};

	useEffect(() => {
		if (pagination.list) {
			fetchListUsers(pagination.list);
		}
	}, [isModalOpen, pagination.list]);

	const fetchData = async (page, pageSize, search, orderby) => {
		try {
			setLoading(true);
			const resperms = await axios.post(
				process.env.REACT_APP_API_URL + "/perms/get/by/user",
			);
			const userPerms = resperms.data;
			const isadmin =
				Boolean(globalUser?.isadmin) ||
				(Array.isArray(userPerms)
					? userPerms.includes("can_see_all_tickets")
					: false);
			const listy = await axios.post("/sprawy/lists/get");
			const newLists = listy.data.data.map((item) => ({
				value: item.swlistid,
				label: item.swlistname,
			}));
			setLists([
				{
					value: "none",
					label: "Wszystkie sprawy - brak wybranej listy",
				},
				...newLists,
			]);
			const response = await axios.post("/sprawy/list/posts", {
				activityMode,
				activityDays,
				pagination: {
					...pagination,
					current: page,
					pageSize: pageSize,
					search: search,
					orderby,
				},
				departs: departs,
				isadmin,
			});
			console.log(response.data.rows);
			setData(response.data.rows);
			persistNavigationIds(response.data.rows);
			setPagination((prev) => ({
				...prev,
				total: response.data.total,
			}));
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoading(false);
		}
	};

	const copyFilteredListToClipboard = async () => {
		if (copyInProgress) return;
		setCopyInProgress(true);
		const hideLoading = message.loading({
			content: "Kopiowanie przefiltrowanej listy…",
			duration: 0,
		});
		try {
			const resperms = await axios.post(
				process.env.REACT_APP_API_URL + "/perms/get/by/user",
			);
			const userPerms = resperms.data;
			const isadmin =
				Boolean(globalUser?.isadmin) ||
				(Array.isArray(userPerms)
					? userPerms.includes("can_see_all_tickets")
					: false);

			const pageSize = 250;
			const sanitizedAdvancedSearch = sanitizeAdvancedSearch(
				pagination?.advancedSearch,
			);
			const basePagination = {
				...pagination,
				advancedSearch: sanitizedAdvancedSearch,
				pageSize,
				orderby: pagination?.orderby || [],
			};

			const fetchPage = async (current) => {
				const response = await axios.post("/sprawy/list/posts", {
					activityMode,
					activityDays,
					pagination: {
						...basePagination,
						current,
					},
					departs,
					isadmin,
				});
				const rows = Array.isArray(response?.data?.rows)
					? response.data.rows
					: [];
				const total = Number(response?.data?.total || 0);
				return { rows, total };
			};

			const first = await fetchPage(1);
			let allRows = [...first.rows];
			const total = first.total;
			const totalPages = Math.max(1, Math.ceil(total / pageSize));
			for (let page = 2; page <= totalPages; page += 1) {
				const next = await fetchPage(page);
				allRows = allRows.concat(next.rows);
			}

			allRows.sort((a, b) => {
				const ap = Number(a?.priorityid);
				const bp = Number(b?.priorityid);
				const apSafe = Number.isFinite(ap) ? ap : 0;
				const bpSafe = Number.isFinite(bp) ? bp : 0;
				if (bpSafe !== apSafe) return bpSafe - apSafe;
				const aid = Number(a?.ticketid);
				const bid = Number(b?.ticketid);
				return (
					(Number.isFinite(bid) ? bid : 0) -
					(Number.isFinite(aid) ? aid : 0)
				);
			});

			const origin =
				typeof window !== "undefined" && window.location?.origin
					? window.location.origin
					: "";

			const lines = allRows.map((ticket) => {
				const ticketId = ticket?.ticketid;
				const ticketNumber =
					ticket?.ticketNumber ||
					(ticketId != null ? `#${ticketId}` : "");
				const url =
					ticketId != null ? origin + buildTicketPath(ticketId) : "";

				const plates = Array.isArray(ticket?.registerPlates)
					? ticket.registerPlates
							.map((p) => normalizeWhitespace(p?.sign))
							.filter(Boolean)
							.join(", ")
					: "";

				const lastPost = truncateToMaxChars(ticket?.contents, 256);
				return [url, ticketNumber, plates, lastPost].join(" | ");
			});

			await writeTextToClipboard(lines.join("\n"));
			message.success(`Skopiowano ${lines.length} pozycji do schowka.`);
		} catch (error) {
			console.error("Copy filtered list failed:", error);
			message.error("Nie udało się skopiować listy.");
		} finally {
			hideLoading();
			setCopyInProgress(false);
		}
	};
	const isInactiveRouteBase =
		storageKeyPrefix === "brakAktywnosci" ||
		(typeof ticketRouteBase === "string" &&
			ticketRouteBase.includes("/sprawy/brak-aktywnosci"));

	// Menu items for the dropdown
	const menu = (
		<Menu>
			<Menu.Item key="1">
				{!isInactiveRouteBase ? (
					<CanWrapper perms={["can_add_new_tickets"]}>
						<Button onClick={() => navigate("/sprawy/nowa")}>
							Nowa sprawa
						</Button>
					</CanWrapper>
				) : null}
			</Menu.Item>
			<Menu.Item key="2">
				<Button
					onClick={() => {
						const specialValue = pagination.advancedSearch?.find(
							(item) => item.name === "special",
						)?.value;
						updateSpecialValue(specialValue === 1 ? 0 : 1);
					}}
					type={
						pagination.advancedSearch?.find(
							(item) => item.name === "special",
						)?.value === 1
							? "primary"
							: "default"
					}
					danger={
						pagination.advancedSearch?.find(
							(item) => item.name === "special",
						)?.value === 1
					}
				>
					Sprawy specjalne
				</Button>
			</Menu.Item>
			<Menu.Item key="6">
				<Button
					onClick={() => {
						const watchedValue = pagination.advancedSearch?.find(
							(item) => item.name === "favorite",
						)?.value;
						const savedContainer =
							localStorage.getItem("globalContainer");
						const selectedList = savedContainer
							? JSON.parse(savedContainer).selectedList || []
							: [];
						if (watchedValue === 1) {
							const updatedList = selectedList.filter(
								(item) => item !== "watched",
							);
							if (updatedList.length === 0) {
								localStorage.removeItem("globalContainer");
							} else {
								setGlobalContainer({
									selectedList: updatedList,
								});
								localStorage.setItem(
									"globalContainer",
									JSON.stringify({
										selectedList: updatedList,
									}),
								);
							}
						} else {
							const newList = [...selectedList, "watched"];
							setGlobalContainer({ selectedList: newList });
							localStorage.setItem(
								"globalContainer",
								JSON.stringify({ selectedList: newList }),
							);
						}
						updateWatchValue(watchedValue === 1 ? 0 : 1);
					}}
					type={
						pagination.advancedSearch?.find(
							(item) => item.name === "favorite",
						)?.value === 1
							? "primary"
							: "default"
					}
					danger={
						pagination.advancedSearch?.find(
							(item) => item.name === "favorite",
						)?.value === 1
					}
				>
					Obserwowane
				</Button>
			</Menu.Item>
			<Menu.Item key="3">
				<AdvancedSearching
					setPagination={setPagination}
					pagination={pagination}
					storageKeyPrefix={storageKeyPrefix}
				/>
			</Menu.Item>
			<Menu.Item key="4">
				<CanWrapper perms={["can_generate_raports"]}>
					<Button onClick={() => generateRaport()}>Raport PDF</Button>
				</CanWrapper>
			</Menu.Item>
			<Menu.Item key="5">
				<CanWrapper perms={["can_generate_raports"]}>
					<UserRaport />
				</CanWrapper>
			</Menu.Item>
			<Menu.Item key="7">
				<Button
					icon={<CopyOutlined />}
					onClick={() => copyFilteredListToClipboard()}
					disabled={copyInProgress}
				>
					Kopiuj listę
				</Button>
			</Menu.Item>
		</Menu>
	);

	const generateRaport = async () => {
		try {
			if (pagination.total > 100) {
				Modal.confirm({
					title: "Czy jesteś pewien?",
					content: `Suma spraw dla jakich chcesz wygenerować raport PDF wynosi ${pagination.total} pozycji. Stworzenie raportu dla tak dużej ilości spraw może chwilę potrwać i nie można go anulować. Jesteś pewien, że chcesz go wygenerować?`,
					onOk: async () => {
						await proceedWithRaport(); // Call the actual function to generate the report
					},
					onCancel() {
						console.log("Cancelled report generation");
					},
					okText: "Wygeneruj",
				});
			} else {
				await proceedWithRaport(); // Call the actual function to generate the report
			}
		} catch (error) {
			console.error("Error in generateRaport:", error);
		}
	};

	const proceedWithRaport = async () => {
		try {
			setPdfModal(true);
			setPercents(0);

			const totalSeconds = Math.ceil(pagination.total / 100);
			const percentIncrement = 100 / totalSeconds;

			const percentInterval = setInterval(() => {
				setPercents((currentPercent) => {
					const updatedPercent = currentPercent + percentIncrement;
					if (updatedPercent >= 100) {
						clearInterval(percentInterval); // Clear interval when reaching 100%
						return 100;
					}
					return Number(updatedPercent.toFixed(2));
				});
			}, 1100); // Update every second

			// Send request to generate the report
			const response = await axios.post("/sprawy/list/raport", {
				activityMode,
				activityDays,
				pagination: pagination,
			});

			// Download the generated report file
			axios({
				url: `/files/download/global/${response.data.filename}`, // Replace with your server URL
				method: "POST",
				responseType: "blob", // Important
			})
				.then((response) => {
					const contentDisposition =
						response.headers["content-disposition"];
					const match = contentDisposition.match(/filename="(.+)"/);
					const url = window.URL.createObjectURL(
						new Blob([response.data]),
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute(
						"download",
						match ? match[1] : "report.pdf",
					); // Use matched filename or a default
					document.body.appendChild(link);
					link.click();
					link.remove();
				})
				.catch((error) => {
					console.error("Download error:", error);
				});

			clearInterval(percentInterval);
			setPercents(100);
			setPdfModal(false);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		// Never fetch an unfiltered list when territory filtering is required.
		if (applyUserTerritoryFilter) {
			if (userAreas == null) return;
			if (Array.isArray(userAreas) && userAreas.length === 0) {
				setData([]);
				setPagination((prev) => ({ ...prev, total: 0 }));
				return;
			}
		}

		fetchData(
			pagination.current,
			pagination.pageSize,
			pagination.search,
			pagination.orderby,
		);
	}, [
		pagination.current,
		pagination.pageSize,
		pagination.search,
		pagination.advancedSearch,
		activityMode,
		reload,
		departs,
		pagination.orderby,
		pagination.list,
		applyUserTerritoryFilter,
		userAreas,
	]);

	// const handleTableChange = (pagination, filters, sorts) => {
	//   saveToLocalStorage('currentPage',pagination.current)
	//   if(sorts.column){
	//     setPagination({
	//       ...pagination,
	//       orderby: [{key: sorts.columnKey, order: sorts.order == 'ascend' ? 'ASC' : 'DESC'}]
	//     });
	//   } else {
	//     setPagination({
	//       ...pagination,
	//       orderby: []
	//     });
	//   }
	// };

	const handleTableChange = (pagination, filters, sorts) => {
		saveToLocalStorage("currentPage", pagination.current);
		if (sorts.column) {
			setPagination({
				...pagination,
				orderby: [
					{
						key: sorts.columnKey,
						order: sorts.order == "ascend" ? "ASC" : "DESC",
					},
				],
			});
		} else {
			setPagination({
				...pagination,
				orderby: [],
			});
		}

		// Handle filtering logic for status
		if (filters.status && filters.status.length > 0) {
			const selectedStatus = filters.status[0]; // Get the first selected filter value
			setSelectedStatusFilter(selectedStatus);
			setPagination((prev) => ({
				...prev,
				advancedSearch: [
					...prev.advancedSearch.filter(
						(item) => item.name !== "swtickets.ticketstatusid",
					), // Remove old filter if it exists
					{ name: "swtickets.ticketstatusid", value: selectedStatus }, // Add new filter
				],
			}));
		} else {
			setSelectedStatusFilter(null);
			setPagination((prev) => ({
				...prev,
				advancedSearch: (prev.advancedSearch || []).filter(
					(item) => item.name !== "swtickets.ticketstatusid",
				),
			}));
		}
	};

	const handlePageSizeChange = (value) => {
		setPagination({
			...pagination,
			pageSize: value,
			current: 1, // Reset to the first page when changing page size
		});
	};

	const handleVisibleColumnsChange = (nextValues) => {
		setVisibleColumnKeys(normalizeVisibleColumns(nextValues));
	};

	const resetVisibleColumns = () => {
		setVisibleColumnKeys([...DEFAULT_OPTIONAL_COLUMN_KEYS]);
	};

	const allColumns = [
		// Define your table columns here
		{
			title: (
				<Flex justify="center">
					<Checkbox
						checked={bulkIDs.length == data.length}
						onChange={() => {
							if (bulkIDs.length == data.length) {
								setBulkIDs([]);
							} else {
								setBulkIDs(data.map((item) => item.ticketid));
							}
						}}
					/>
				</Flex>
			),
			dataIndex: "bulk_edit_checkbox",
			key: "bulk_edit_checkbox",
			width: 48,
			render: (item, record) => (
				<Flex justify="center">
					<Checkbox
						checked={bulkIDs.includes(record.ticketid)}
						onChange={() => {
							setBulkIDs((prevBulkIDs) => {
								// Check if ticketid is already in the bulkIDs
								if (prevBulkIDs.includes(record.ticketid)) {
									// If it's checked, remove it from the array
									return prevBulkIDs.filter(
										(id) => id !== record.ticketid,
									);
								} else {
									// If it's not checked, add it to the array
									return [...prevBulkIDs, record.ticketid];
								}
							});
						}}
					/>
				</Flex>
			),
		},
		{
			title: "ID Sprawy",
			dataIndex: "ticketid",
			key: "ticketid",
			width: 100,
			render: (item, record) => {
				return (
					<div
						style={{ fontSize: "18px", textAlign: "right" }}
						onClick={() => {
							persistNavigationIds();
							navigate(buildTicketPath(record.ticketid));
						}}
					>
						#{record.ticketid}
					</div>
				);
			},
		},
		{
			title: "Sprawa",
			dataIndex: "subject",
			key: "subject",
			width: 560,
			render: (item, record) => {
				return (
					<div
						className={
							record.watcher_visited == "1" ? "nonvisited" : ""
						}
						style={{
							display: "flex",
							gap: "10px",
							cursor: "pointer",
							maxWidth: "760px",
							minWidth: "220px",
						}}
						onClick={() => {
							persistNavigationIds();
							navigate(buildTicketPath(record.ticketid));
						}}
					>
						{record.ss == "1" ? (
							<div
								style={{
									height: "50px",
									width: "30px",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									background: "#ff4d4f",
									fontSize: "18px",
									fontWeight: "700",
									color: "white",
									flex: "none",
								}}
							>
								SS
							</div>
						) : (
							<></>
						)}
						{record.is_dateline_selected == "1" ? (
							<div
								style={{
									height: "30px",
									width: "auto",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									background: "#ff4d4f",
									fontSize: "10px",
									fontWeight: "700",
									color: "white",
									flex: "none",
									padding: "0 5px",
								}}
							>
								BRAK AKTYWNOŚCI
							</div>
						) : (
							<></>
						)}
						{record.watcher_visited == "1" ? (
							<div
								style={{
									height: "50px",
									width: "30px",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									background: "#3F51B5",
									fontSize: "18px",
									fontWeight: "700",
									color: "white",
									padding: "0 10px",
								}}
							>
								N
							</div>
						) : (
							<></>
						)}
						<div>
							<Text style={{ fontSize: "16px" }}>
								{record.priorityid == "4" ? (
									<span
										style={{
											color: "red",
											fontWeight: "700",
										}}
									>
										!PILNE -{" "}
									</span>
								) : null}
								{record.priorityid == "3" ? (
									<span
										style={{
											color: "red",
											fontWeight: "700",
										}}
									>
										!WAŻNE -{" "}
									</span>
								) : null}
								<>
									{record.is_favorite ? (
										<span
											style={{
												height: "20px",
												width: "20px",
												display: "inline-flex",
												marginRight: "5px",
												justifyContent: "center",
												alignItems: "center",
												background: "#B57531",
											}}
										>
											<EyeOutlined
												style={{ color: "white" }}
											></EyeOutlined>
										</span>
									) : (
										<></>
									)}
									{item}
								</>
							</Text>
							<div
								style={{
									display: "flex",
									gap: "10px",
									flexWrap: "wrap",
									alignItems: "center",
								}}
							>
								<Text
									style={{
										fontSize: "12px",
										color: "rgba(0, 0, 0, 0.60)",
										display: "block",
									}}
								>
									{datetimeParser(
										record.dateline,
										"YYYY-MM-DD HH:mm:ss",
									)}
								</Text>
								{record.registerPlates.map((plate, index) => (
									<div
										key={index}
										style={{
											display: "inline-flex",
											alignItems: "center",
											gap: "4px",
										}}
									>
										<Tooltip title={plate.description}>
											<div
												style={{
													display: "flex",
													alignItems: "center",
													borderRadius: "2px",
													background: "white",
													border: "1px solid black",
												}}
											>
												<div
													style={{
														width: "10px",
														height: "20px",
														background: "#015CAD",
														display: "flex",
														padding: "2px 2px",
														alignItems: "end",
														flexDirection: "column",
														justifyContent:
															"space-between",
													}}
												>
													<div
														style={{
															fontSize: "6px",
															color: "white",
															border: "1px dotted white",
															width: "6px",
															height: "6px",
															borderRadius:
																"100%",
														}}
													></div>
													<div
														style={{
															fontSize: "6px",
															color: "white",
															lineHeight: "6px",
														}}
													>
														PL
													</div>
												</div>
												<div
													style={{
														fontWeight: "500",
														color: "black",
														padding: "0 7px",
														fontSize: "12px",
													}}
												>
													{plate.sign}
												</div>
											</div>
										</Tooltip>
										{Number(record?.signedcontracts) > 0 ? (
											<span
												style={{
													display: "inline-flex",
													gap: "2px",
												}}
											>
												{Array.from({
													length: Number(
														record?.signedcontracts,
													),
												}).map((_, i) => (
													<CheckOutlined
														key={i}
														style={{
															color: "black",
															fontSize: "12px",
														}}
													/>
												))}
											</span>
										) : null}
									</div>
								))}
							</div>
							{pagination.search == "" ? (
								<></>
							) : (
								<HighlightShort
									textContent={record.contents}
									searchString={pagination.search}
								/>
							)}
						</div>
					</div>
				);
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			width: 180,
			filters: values?.ticketstatusid.map((item) => ({
				text: item.label,
				value: item.value,
			})),
			// Use onFilter to filter records based on the selected status
			onFilter: (value, record) => {
				setSelectedStatusFilter(value); // Set the selected status to ensure only one checkbox is checked
				return true;
			},
			filteredValue: selectedStatusFilter ? [selectedStatusFilter] : [], // Ensure only one checkbox is checked
			render: (item, record) => {
				return <CaseStatus record={record} />;
			},
		},
		{
			title: "Konkurencja",
			dataIndex: "competitionis",
			key: "competitionis",
			width: 130,
			render: (item, record) => {
				if (!Number(record?.competitionis)) {
					return "Nie";
				}
				return record?.competitionnames || "Tak";
			},
		},
		{
			title: "Przypomnienie",
			dataIndex: "next_reminder_dateline",
			key: "next_reminder_dateline",
			width: 170,
			render: (item, record) => {
				if (isClosedReminderStatus(record)) return "Brak";
				const nextDate = Number(record?.next_reminder_dateline || 0);
				const hasNextDate = Number.isFinite(nextDate) && nextDate > 0;
				const isOverdue = Number(record?.reminder_overdue || 0) === 1;
				if (!hasNextDate && !isOverdue) return "Brak";
				if (!hasNextDate && isOverdue) {
					return (
						<div style={{ color: "#cf1322", fontWeight: 600 }}>
							Zaległe
						</div>
					);
				}
				return (
					<div>
						{datetimeParser(nextDate, "YYYY-MM-DD HH:mm")}
						{isOverdue ? (
							<div style={{ color: "#cf1322", fontWeight: 600 }}>
								Zaległe
							</div>
						) : null}
					</div>
				);
			},
		},
		{
			title: "Ostatnia zmiana",
			dataIndex: "lastactivity",
			key: "lastactivity",
			width: 180,
			sorter: true,
			render: (item, record) => {
				return (
					<div class="min-200">
						{datetimeParser(
							record.lastactivity,
							"YYYY-MM-DD HH:mm:ss",
						)}
						<div>{record?.userDetailsLast?.mlg_users_fullname}</div>
					</div>
				);
			},
		},
		{
			title: "Data zdarzenia",
			dataIndex: "accident_dateline",
			key: "accident_dateline",
			width: 150,
			sorter: true,
			render: (item, record) => {
				return (
					<div class="min-200">
						{datetimeParser(record.accident_dateline, "YYYY-MM-DD")}
					</div>
				);
			},
		},
		{
			title: "Zgłaszający",
			dataIndex: "phone",
			key: "phone",
			width: 190,
			render: (item, record) => {
				return <SimpleAvatar user={record.userDetails}></SimpleAvatar>;
			},
		},
		{
			title: "Przypisany",
			dataIndex: "przypisany",
			key: "przypisany",
			width: 190,
			render: (item, record) => {
				return (
					<SimpleAvatar
						user={record.userDetailsPrzypisany}
					></SimpleAvatar>
				);
			},
		},
	];

	const columns = allColumns.filter(
		(column) =>
			LOCKED_COLUMN_KEYS.has(column.key) ||
			visibleColumnKeys.includes(column.key),
	);

	const columnOptions = useMemo(() => {
		return DEFAULT_OPTIONAL_COLUMN_KEYS.map((key) => ({
			label: COLUMN_LABELS[key] || key,
			value: key,
		}));
	}, []);

	const getAdvancedSearchIds = (name) => {
		const item = (pagination.advancedSearch || []).find(
			(x) => x?.name === name,
		);
		const rawValue = item?.value;
		if (Array.isArray(rawValue) && Array.isArray(rawValue[0])) {
			return rawValue[0]
				.map((x) => Number(x))
				.filter((x) => Number.isFinite(x));
		}
		return [];
	};

	const setAdvancedSearchIds = (name, ids) => {
		setPagination((prev) => {
			const prevAdvancedSearch = prev.advancedSearch || [];
			const without = prevAdvancedSearch.filter((x) => x?.name !== name);
			const normalized = (Array.isArray(ids) ? ids : [])
				.map((x) => Number(x))
				.filter((x) => Number.isFinite(x));
			const next = normalized.length
				? [...without, { name, value: [normalized] }]
				: without;
			return { ...prev, advancedSearch: next, current: 1 };
		});
	};

	const formatIdsWithLabels = (ids, options) => {
		const safeIds = Array.isArray(ids) ? ids : [];
		const safeOptions = Array.isArray(options) ? options : [];
		const labelById = new Map();
		safeOptions.forEach((opt) => {
			const numericId = Number(opt?.value);
			if (!Number.isFinite(numericId)) return;
			labelById.set(
				numericId,
				(opt?.label ?? opt?.name ?? String(opt?.value)).toString(),
			);
		});
		return safeIds.map((id) => {
			const numericId = Number(id);
			return labelById.get(numericId) ?? String(id);
		});
	};

	const RightFiltersPanel = () => {
		const wojIds = getAdvancedSearchIds(
			"swadministrationelementsticket.woj",
		);
		const powiatIds = getAdvancedSearchIds(
			"swadministrationelementsticket.powiat",
		);
		const gminaIds = getAdvancedSearchIds(
			"swadministrationelementsticket.gmina",
		);
		const statusIds = getAdvancedSearchIds("swtickets.ticketstatusid");
		const tagIds = getAdvancedSearchIds("stl.tagid");
		const labelOptions =
			(values?.woj && Array.isArray(values.woj)) ||
			(values?.powiat && Array.isArray(values.powiat)) ||
			(values?.gmina && Array.isArray(values.gmina))
				? []
				: territoryLabelOptions;

		return (
			<div style={{ padding: "20px" }}>
				{typeof onFilterModeChange === "function" ? (
					<>
						<Typography.Text strong>Filtr</Typography.Text>
						<div style={{ marginTop: "10px" }}>
							<Segmented
								options={[
									{ label: "Obszary", value: "areas" },
									{ label: "Tagi", value: "tags" },
								]}
								value={filterMode}
								onChange={(value) => onFilterModeChange(value)}
							/>
						</div>
					</>
				) : null}

				{isAdmin && typeof onShowAllTicketsChange === "function" ? (
					<div style={{ marginTop: "16px" }}>
						<Typography.Text strong>Zakres widoku</Typography.Text>
						<div style={{ marginTop: "10px" }}>
							<Segmented
								options={[
									{
										label: "Moje obszary",
										value: "mine",
									},
									{
										label: "Wszystkie sprawy",
										value: "all",
									},
								]}
								value={showAllTickets ? "all" : "mine"}
								onChange={(value) =>
									onShowAllTicketsChange(value === "all")
								}
							/>
						</div>
					</div>
				) : null}

				{applyUserTerritoryFilter &&
				Array.isArray(userAreas) &&
				userAreas.length === 0 ? (
					<Alert
						type="warning"
						showIcon
						message="Brak ustawionych obszarów działań"
						description={
							<div>
								Aby filtrowanie działało, musisz mieć przypisany
								co najmniej jeden obszar. Skontaktuj się z
								administratorem.
							</div>
						}
					/>
				) : null}

				<Typography.Text strong>Filtry</Typography.Text>

				<div style={{ marginTop: "16px" }}>
					<Typography.Text>Województwo (auto)</Typography.Text>
					<div style={{ marginTop: "6px" }}>
						<Typography.Text type="secondary">
							{wojIds.length
								? formatIdsWithLabels(
										wojIds,
										values?.woj || labelOptions,
									).join(", ")
								: "Brak"}
						</Typography.Text>
					</div>
				</div>

				<div style={{ marginTop: "12px" }}>
					<Typography.Text>Powiat (auto)</Typography.Text>
					<div style={{ marginTop: "6px" }}>
						<Typography.Text type="secondary">
							{powiatIds.length
								? formatIdsWithLabels(
										powiatIds,
										values?.powiat || labelOptions,
									).join(", ")
								: "Brak"}
						</Typography.Text>
					</div>
				</div>

				<div style={{ marginTop: "12px" }}>
					<Typography.Text>Gmina (auto)</Typography.Text>
					<div style={{ marginTop: "6px" }}>
						<Typography.Text type="secondary">
							{gminaIds.length
								? formatIdsWithLabels(
										gminaIds,
										values?.gmina || labelOptions,
									).join(", ")
								: "Brak"}
						</Typography.Text>
					</div>
				</div>

				<div style={{ marginTop: "16px" }}>
					<Typography.Text>Status sprawy</Typography.Text>
					<Select
						mode="multiple"
						allowClear
						showSearch
						filterOption={filterOption}
						style={{ width: "100%", marginTop: "6px" }}
						options={values?.ticketstatusid || []}
						value={statusIds}
						onChange={(next) =>
							setAdvancedSearchIds(
								"swtickets.ticketstatusid",
								next,
							)
						}
						placeholder="Wybierz status"
					/>
				</div>

				{filterMode === "tags" && (
					<div style={{ marginTop: "16px" }}>
						<Typography.Text>Tagi sprawy</Typography.Text>
						<Select
							mode="multiple"
							allowClear
							showSearch
							filterOption={filterOption}
							style={{ width: "100%", marginTop: "6px" }}
							options={values?.tags || []}
							value={tagIds}
							onChange={(next) =>
								setAdvancedSearchIds("stl.tagid", next)
							}
							placeholder="Wybierz tagi"
						/>
					</div>
				)}
			</div>
		);
	};

	const tableScrollY = Math.max(
		300,
		viewportHeight - (showRightFiltersPanel ? 360 : 320),
	);
	const showDesktopRightPanel = showRightFiltersPanel && viewportWidth > 1400;
	const isMobileViewport = viewportWidth <= 1000;

	return (
		<>
			<div
				style={
					showRightFiltersPanel
						? {
								display: "grid",
								gridTemplateColumns: showDesktopRightPanel
									? "minmax(0, 1fr) 360px"
									: "minmax(0, 1fr)",
								height: "100%",
							}
						: undefined
				}
			>
				<div>
					<Spin spinning={loading}>
						<div
							style={{
								display: "flex",
								width: "100%",
								gap: "10px",
								padding: "20px 20px 0 20px",
								boxSizing: "border-box",
								minWidth: 0,
								flexWrap: "wrap",
								flexDirection: isMobileViewport
									? "column"
									: "row",
							}}
						>
							<Modal
								title={`Edytuj listę '${
									lists.find(
										(list) =>
											list.value === pagination.list,
									)?.label
								}'`}
								open={isModalOpen}
								onOk={async () => {
									try {
										await axios.post("/sprawy/lists/save", {
											users: selectedUsers,
											owner: selectedListUser,
											listInfo: selectedListInfo,
											listid: pagination.list,
										});
										message.success(
											"Lista została zapisana",
										);
										setIsModalOpen(false);
									} catch (error) {
										message.error(
											"Wystąpił błąd podczas zapisywania listy",
										);
										console.error(error);
									}
								}}
								onCancel={() => setIsModalOpen(false)}
								width={800}
								okText="Zapisz"
							>
								<Form
									layout="vertical"
									name="listusers"
									style={{ marginTop: "20px" }}
								>
									<Form.Item label="Nazwa listy">
										<Input
											placeholder="Wprowadź nazwę listy"
											value={
												selectedListInfo
													? selectedListInfo.swlistname
													: ""
											}
											loading={!values}
											onChange={(e) =>
												setSelectedListInfo({
													...selectedListInfo,
													swlistname: e.target.value,
												})
											}
										/>
									</Form.Item>

									<Form.Item label="Właściciel listy">
										<Select
											style={{ width: "100%" }}
											placeholder="Wybierz pracownika"
											value={selectedListUser}
											onChange={setSelectedListUser}
											loading={!values}
										>
											{values?.userid
												?.filter(
													(user) =>
														!user.hidden ||
														selectedUsers.includes(
															user.value,
														),
												)
												?.map((user) => (
													<Select.Option
														key={user.value}
														value={user.value}
														disabled={user.hidden}
													>
														{user.label}
													</Select.Option>
												))}
										</Select>
									</Form.Item>
									<Form.Item label="Przypisani pracownicy do listy">
										<Select
											mode="multiple"
											style={{ width: "100%" }}
											placeholder="Wybierz pracowników"
											value={selectedUsers}
											onChange={(values) => {
												const uniqueValues = [
													...new Set(values),
												];
												setSelectedUsers(uniqueValues);
											}}
											loading={!values}
											allowClear
										>
											{values?.userid
												?.filter(
													(user) =>
														!user.hidden ||
														selectedUsers.includes(
															user.value,
														),
												)
												?.map((user) => (
													<Select.Option
														key={user.value}
														value={user.value}
														disabled={user.hidden}
													>
														{user.label}
													</Select.Option>
												))}
										</Select>
									</Form.Item>
								</Form>
								<Button
									type="primary"
									danger
									onClick={async () => {
										try {
											await axios.post(
												`/sprawy/lists/delete`,
												{
													listid: selectedListInfo.swlistid,
												},
											);
											setPagination({
												...pagination,
												list: "none",
											});
											setSelectedListInfo(null);
											setIsModalOpen(false);
										} catch (error) {
											message.error(
												"Wystąpił błąd podczas usuwania listy",
											);
										}
									}}
								>
									Usuń listę
								</Button>
							</Modal>
							{selectedListInfo ? (
								pagination.list &&
								pagination.list != "none" &&
								(globalUser.isadmin ||
									globalUser.user.mlg_users_id ==
										selectedListInfo.userid) && (
									<Button
										onClick={() => setIsModalOpen(true)}
									>
										Edytuj listę
									</Button>
								)
							) : (
								<></>
							)}
							<Select
								placeholder="Wybierz listę"
								value={pagination.list}
								style={{
									width: "100%",
									flex: "1",
									minWidth: 0,
								}}
								onChange={(e) => {
									setPagination({
										...pagination,
										list: e,
										current: 1, // Reset to the first page when changing page size
									});
								}}
							>
								{lists.map((option) => (
									<option
										key={option.value}
										value={option.value}
									>
										{option.label}
									</option>
								))}
							</Select>
						</div>
					</Spin>
					<div
						className="smallResCol"
						size="large"
						style={{
							display: "flex",
							width: "100%",
							gap: "10px",
							padding: "10px 20px 0px 20px",
							boxSizing: "border-box",
							minWidth: 0,
							flexDirection: isMobileViewport ? "column" : "row",
						}}
					>
						<BulkEdit
							reload={reload}
							setReload={setReload}
							ids={bulkIDs}
							pagination={pagination}
						></BulkEdit>
						<div
							style={{
								display: "flex",
								width: "100%",
								minWidth: 0,
								flexWrap: isMobileViewport ? "wrap" : "nowrap",
							}}
						>
							<Input
								style={{
									minWidth: isMobileViewport ? 0 : 220,
									flex: "1 1 220px",
								}}
								value={searchValue} // Bind the input value to state
								onChange={(e) => setSearchValue(e.target.value)} // Update state on input change
								onPressEnter={handleSearch} // Trigger search on Enter key press
								disabled={loading} // Disable input if loading
								addonBefore={
									<SearchOutlined onClick={handleSearch} />
								} // Trigger search on icon click
								placeholder="Wyszukaj sprawę | #ID, @tag, Tytuł, treść, województwo, powiat, gmina"
							/>
							<Button
								onClick={handleSearch}
								disabled={loading}
								style={{
									width: isMobileViewport ? "100%" : "auto",
								}}
							>
								Wyszukaj
							</Button>{" "}
							{/* Trigger search on button click */}
						</div>
						<div
							className="hideMobile"
							style={{
								display: "flex",
								width: "100%",
								gap: "10px",
								minWidth: 0,
								flexWrap: "wrap",
								alignItems: "flex-start",
							}}
						>
							{!isInactiveRouteBase ? (
								<CanWrapper perms={["can_add_new_tickets"]}>
									<Button
										style={{}}
										onClick={() => navigate("/sprawy/nowa")}
									>
										Nowa sprawa
									</Button>
								</CanWrapper>
							) : null}
							<Button
								style={{}}
								onClick={() => {
									pagination.advancedSearch?.find(
										(item) => item.name === "special",
									)?.value == 1
										? updateSpecialValue(0)
										: updateSpecialValue(1);
								}}
								type={
									pagination.advancedSearch?.find(
										(item) => item.name === "special",
									)?.value == 1
										? "primary"
										: "default"
								}
								danger={
									pagination.advancedSearch?.find(
										(item) => item.name === "special",
									)?.value == 1
								}
							>
								Sprawy specjalne
							</Button>
							<Button
								onClick={() => {
									const watchedValue =
										pagination.advancedSearch?.find(
											(item) => item.name === "favorite",
										)?.value;
									const savedContainer =
										localStorage.getItem("globalContainer");
									const selectedList = savedContainer
										? JSON.parse(savedContainer)
												.selectedList || []
										: [];
									if (watchedValue === 1) {
										const updatedList = selectedList.filter(
											(item) => item !== "watched",
										);
										if (updatedList.length === 0) {
											localStorage.removeItem(
												"globalContainer",
											);
										} else {
											setGlobalContainer({
												selectedList: updatedList,
											});
											localStorage.setItem(
												"globalContainer",
												JSON.stringify({
													selectedList: updatedList,
												}),
											);
										}
									} else {
										const newList = [
											...selectedList,
											"watched",
										];
										setGlobalContainer({
											selectedList: newList,
										});
										localStorage.setItem(
											"globalContainer",
											JSON.stringify({
												selectedList: newList,
											}),
										);
									}
									updateWatchValue(
										watchedValue === 1 ? 0 : 1,
									);
								}}
								type={
									pagination.advancedSearch?.find(
										(item) => item.name === "favorite",
									)?.value === 1
										? "primary"
										: "default"
								}
								danger={
									pagination.advancedSearch?.find(
										(item) => item.name === "favorite",
									)?.value === 1
								}
							>
								Obserwowane
							</Button>
							<AdvancedSearching
								setPagination={setPagination}
								pagination={pagination}
								storageKeyPrefix={storageKeyPrefix}
							></AdvancedSearching>
							<Dropdown
								trigger={["click"]}
								dropdownRender={() => (
									<div
										style={{
											background: "white",
											borderRadius: "8px",
											boxShadow:
												"0 6px 16px rgba(0, 0, 0, 0.12)",
											padding: "12px",
											width: "260px",
										}}
									>
										<Typography.Text strong>
											Widoczne kolumny
										</Typography.Text>
										<div style={{ marginTop: "8px" }}>
											<Checkbox.Group
												value={visibleColumnKeys}
												onChange={
													handleVisibleColumnsChange
												}
												style={{ width: "100%" }}
											>
												<div
													style={{
														display: "flex",
														flexDirection: "column",
														gap: "8px",
													}}
												>
													{columnOptions.map(
														(option) => (
															<Checkbox
																key={
																	option.value
																}
																value={
																	option.value
																}
															>
																{option.label}
															</Checkbox>
														),
													)}
												</div>
											</Checkbox.Group>
										</div>
										<Button
											size="small"
											style={{
												marginTop: "10px",
												width: "100%",
											}}
											onClick={resetVisibleColumns}
										>
											Przywróć domyślne
										</Button>
									</div>
								)}
							>
								<Button icon={<FilterOutlined />}>
									Kolumny
								</Button>
							</Dropdown>
							<Tooltip title="Kopiuj przefiltrowaną listę do schowka">
								<Button
									icon={<CopyOutlined />}
									onClick={() =>
										copyFilteredListToClipboard()
									}
									disabled={copyInProgress}
								>
									Kopiuj listę
								</Button>
							</Tooltip>
							<CanWrapper perms={["can_generate_raports"]}>
								<Button
									style={{}}
									onClick={() => generateRaport()}
								>
									Raport PDF
								</Button>
							</CanWrapper>
							<CanWrapper perms={["can_generate_raports"]}>
								<UserRaport></UserRaport>
							</CanWrapper>
						</div>
						<Modal
							centered={true}
							open={pdfModal}
							title="Generowanie raportu PDF"
							onOk={() => {}}
							onCancel={() => {}}
							footer={[]}
						>
							<Progress
								percent={percent}
								type="line"
							/>
						</Modal>
						<Dropdown
							className="showMobile"
							overlay={menu}
							trigger={["click"]}
							onOpenChange={(flag) => setOpen(flag)}
							open={open}
						>
							<Button>
								Akcje i filtry <DownOutlined />
							</Button>
						</Dropdown>
						{/* <ButtonS icon={<FilterOutlined />} className='shopOn800px' style={{width: "40px"}} onClick={() => setShowFilters(!showFilters)}></ButtonS> */}
					</div>
					<div
						className="overflowTable"
						style={{
							padding: isMobileViewport ? "0px 10px" : "0px 20px",
							boxSizing: "border-box",
							minWidth: 0,
						}}
					>
						{showActivityRangeToggle &&
						typeof onActivityRangeChange === "function" ? (
							<div
								style={{
									padding: "10px 0 0 0",
									display: "flex",
									justifyContent: "flex-start",
								}}
							>
								<Segmented
									options={[
										{
											label: "Tylko aktywne",
											value: "active",
										},
										{
											label: "Aktywne + nieaktywne",
											value: "all",
										},
									]}
									value={activityRangeValue}
									onChange={(value) =>
										onActivityRangeChange(value)
									}
								/>
							</div>
						) : null}
						<Spin spinning={loading}>
							<Table
								className="dynamic-rows-table"
								size="small"
								scroll={{ x: "max-content", y: tableScrollY }}
								sticky
								style={{
									width: "100%",
									gap: "10px",
									marginTop:
										showActivityRangeToggle &&
										typeof onActivityRangeChange ===
											"function"
											? "10px"
											: "20px",
								}}
								columns={columns}
								dataSource={data}
								pagination={{
									...pagination,
									position: ["topRight", "bottomRight"],
									showSizeChanger: true,
									pageSizeOptions: ["20", "40", "50"],
									onShowSizeChange: handlePageSizeChange,
									showQuickJumper: true,
									showTotal: (total, range) =>
										`${range[0]}-${range[1]} z ${total} elementów`, // Customize total display
									locale: {
										items_per_page: "/ stronę", // Customize the text in the select dropdown
									},
								}}
								onChange={handleTableChange}
								rowKey={(record) => record.id}
								locale={{ emptyText: "Brak danych" }}
								onRow={(record) => ({
									style: {
										opacity: record.statusopacity
											? Math.min(
													Math.max(
														record.statusopacity,
														0,
													),
													1,
												)
											: 1,
										background:
											record.statusopacity != 1
												? "#80808085"
												: "",
									},
								})}
							/>
						</Spin>
					</div>
				</div>

				{showDesktopRightPanel ? (
					<div
						className="hideOn800px"
						style={{
							boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.15)",
							background: "white",
							height: "100%",
							overflow: "auto",
						}}
					>
						<RightFiltersPanel />
					</div>
				) : null}
			</div>
		</>
	);
};

export default DataTable;
